import { Fire } from "@phosphor-icons/react";

export default function SeatsLeft({ next, className = "" }) {
  if (!next || typeof next.seats_left !== "number") return null;
  const { seats_left: left, capacity } = next;
  const urgent = left <= 3;
  if (left <= 0) {
    return <span className={`font-mono text-[10px] tracking-[0.18em] uppercase text-red-400 ${className}`} data-testid="seats-left">Next class sold out</span>;
  }
  return (
    <span className={`inline-flex items-center gap-1.5 font-mono text-[10px] tracking-[0.18em] uppercase ${urgent ? "text-orange-400" : "text-neutral-400"} ${className}`} data-testid="seats-left">
      {urgent && <Fire size={12} weight="fill" />}
      Only {left} of {capacity} seat{left !== 1 ? "s" : ""} left
    </span>
  );
}
